import React from 'react';

import {SortArrows} from './dataTableIcons.js'

const HeaderSortControl = props => (
  <span class="header-action-wrap">
    <SortArrows />
  </span>
);

export default HeaderSortControl;
